export interface CleanValidationActionType {
  type: '@formCreator/CLEAN_VALIDATION';
}

export type CleanValidationFunctionType = () => void;

export const cleanValidation = (): CleanValidationActionType => ({
  type: '@formCreator/CLEAN_VALIDATION',
});
